// Where a customer transferring the money should send it. Printed on every
// invoice and on estimates that ask for payment, so this is the one place to
// edit if the shop ever changes banks.
export const BANK_DETAILS = [
  ["Bank", "Commercial Bank"],
  ["Branch", "Ja-ela"],
  ["Account Name", "NSS Auto Engineers"],
  ["Account No.", "1000956014"],
];
